<template>
  <router-view />
</template>

<script>
export default {
  name: 'TestsIndex'
}
</script>
